import {
	getProductStockSkuDetail,
	postProductStockAPI,
} from '../../services/api/productStock.api';
import {
	GET_SKU_SINGLE_REQUEST,
	GET_SKU_SINGLE_SUCCESS,
	GET_SKU_SINGLE_FAILURE,
	PUT_PRODUCT_STOCK_REQUEST,
	PUT_PRODUCT_STOCK_SUCCESS,
	PUT_PRODUCT_STOCK_FAILURE,
} from '../types';
import { transformStockSkuDetail } from '../../transforms/stock';
import { transformError } from '../../transforms/error';
import i18n from '../../plugins/i18n';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformStockSkuDetail({}),
	},

	mutations: {
		[GET_SKU_SINGLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = {};
		},
		[GET_SKU_SINGLE_SUCCESS](state, { data }) {
			state.isLoading = false;
			state.data = transformStockSkuDetail(data);
		},
		[GET_SKU_SINGLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getProductStockSkuDetail({ commit }, { id = null }) {
			try {
				commit(GET_SKU_SINGLE_REQUEST);
				const { data } = await getProductStockSkuDetail(id);
				commit(GET_SKU_SINGLE_SUCCESS, data);
			} catch (error) {
				commit(GET_SKU_SINGLE_FAILURE, error);
			}
		},
		async postProductStock({ commit }, params = {}) {
			try {
				commit(PUT_PRODUCT_STOCK_REQUEST);
				await postProductStockAPI(params);
				commit(PUT_PRODUCT_STOCK_SUCCESS);
			} catch (error) {
				commit(PUT_PRODUCT_STOCK_FAILURE, error);
				// show toast
				this.dispatch('toast/showToast', {
					header: i18n.t('toast.error'),
					content: i18n.t('toast.unexpectedError'),
					type: 'danger',
				});
			}
		},
	},
};
